import { render } from "./ImportGroupResultForm.vue?vue&type=template&id=36da06b2&scoped=true&ts=true"
import script from "./ImportGroupResultForm.vue?vue&type=script&lang=ts"
export * from "./ImportGroupResultForm.vue?vue&type=script&lang=ts"

import "./ImportGroupResultForm.vue?vue&type=style&index=0&id=36da06b2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36da06b2"]])

export default __exports__